import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'

interface Props {
  isDisabled: boolean
}

const InternalUserStatusChipComponent = ({ isDisabled }: Props) => {
  if (isDisabled) {
    return (
      <Chip
        text="Disabled"
        className={tw`bg-critical-50`}
        textClassName={tw`text-critical-500`}
        dataTestId="internal-user-status-disabled"
      />
    )
  }

  return (
    <Chip
      text="Active"
      className={tw`bg-success-200`}
      textClassName={tw`text-success-500`}
      dataTestId="internal-user-status-active"
    />
  )
}

export const InternalUserStatusChip = memo(InternalUserStatusChipComponent)
